import { render, staticRenderFns } from "./CardClientParent.vue?vue&type=template&id=611d12aa&scoped=true"
import script from "./CardClientParent.vue?vue&type=script&lang=js"
export * from "./CardClientParent.vue?vue&type=script&lang=js"
import style0 from "./CardClientParent.vue?vue&type=style&index=0&id=611d12aa&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "611d12aa",
  null
  
)

export default component.exports